var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "progress-bar margin-y-md" }, [
    _c(
      "div",
      {
        staticStyle: {
          height: "var(--spacing-md)",
          "background-color": "var(--gray-100)",
          "border-radius": "var(--border-radius-pill)",
          "margin-bottom": "var(--spacing-sm)",
        },
      },
      [
        _c("div", {
          style: `height: var(--spacing-md); border-radius: var(--border-radius-pill); min-width: var(--spacing-md); background-color: var(${_vm.progressBar.color}); width: ${_vm.progressBar.size};`,
        }),
      ]
    ),
    _vm._v(" "),
    _vm.isShowingDetails
      ? _c("dl", { staticClass: "margin-0 padding-0" }, [
          _c("dt", { staticClass: "sr-only" }, [_vm._v("Current Usage")]),
          _vm._v(" "),
          _c(
            "dd",
            { staticClass: "display-flex flex-content-between muted size-sm" },
            [
              _vm.isShowingPercentage && _vm.currentPercentage > 0
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.formatNumber(_vm.currentPercentage, {
                          precision: _vm.precision,
                        })
                      ) + "%"
                    ),
                  ])
                : _vm.isShowingLabel
                ? _c("span", [_vm._v(_vm._s(_vm.label))])
                : _vm._e(),
              _vm._v(" "),
              _vm.unlimited
                ? _c(
                    "span",
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.value) + " of\n        "
                      ),
                      _c("font-awesome-icon", {
                        attrs: { icon: _vm.$v7.regular.faInfinity },
                      }),
                    ],
                    1
                  )
                : _c("span", [
                    _vm._v(
                      _vm._s(_vm.value) +
                        " of " +
                        _vm._s(_vm.limit) +
                        _vm._s(_vm.unit)
                    ),
                  ]),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }